import { render, staticRenderFns } from "./BadgeWidgets.vue?vue&type=template&id=501f61d4&"
import script from "./BadgeWidgets.js?vue&type=script&lang=js&"
export * from "./BadgeWidgets.js?vue&type=script&lang=js&"
import style0 from "./BadgeWidgets.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports